import React, { Component } from 'react';
import formDataSchema from '../../../schema/tat-report';
import logSchema from '../../../schema/log-report';
// import Inputlayer from '../../../../components/FormComponent/Input';
// import { filter, formData, dissableFormData } from '../../../../schema/apppointment';
import { Table, Tag } from 'antd';

import { Pagination } from 'antd';
import moment from 'moment';
import { CSVLink } from "react-csv";
import * as R from 'ramda';
// import Pagination from "react-js-pagination";
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import { Switch, Spin, Tooltip, Modal, Button, notification } from 'antd';
import DateRange from '../../../components/FormComponent/DateRange';
import Select2 from '../../../components/FormComponent/select2';
import Inputlayer from '../../../components/FormComponent/Input';
const $ = require('jquery');
const {homepage} = networkList;
class Query_Report extends Component {
    // print = () => {
    //     window.print();
    // }

    csvLink = React.createRef()

    constructor(props) {
        super(props);
        this.state = {
            date: '',
            appTime: [],
            headding: null,
            postdata: {},
            formData: [],
            reportData: [],
            reportHead: [],
            reportExcelData: [],
            visible: false,
            dateTo: moment().format('YYYY-MM-DD'),
            dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
            activePage: 1,
            totalItemsCount: 0,
            isLoading: false,
            downloadStatus: 0,
            'thead': [],
            'tbody': [],
            'downloadtbody': [],
            search: ""
        };
    }

    componentDidMount() {
        let { slug } = this.props.match.params;
        let formSchema = Object.assign({}, formDataSchema);
        formSchema['feilds'].map((feild, key) => {
            formSchema['feilds'][key]['value'] = null;
            formSchema['feilds'][key]['valid'] = false;
            formSchema['feilds'][key]['errors'] = [];
            delete formSchema['feilds'][key]['text'];

        })
        this.setState(({ 'formData': formSchema['feilds'] }), () => {
            this.fetchData(this.state.formData);
            // this.renderHead();
            this.loadPage()
        })
    //    }

    }

    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }

    componentDidUpdate(prevProps, prevState) {
        try {
            let { id, slug } = this.props.match.params;
            let { menuList } = this.props;
            let prevSlug = prevProps.match.params.slug;
            if (slug !== prevSlug) {
                menuList.map((menu) => {
                    if (slug !== undefined && slug !== null && slug !== '') {
                        if (menu['route'] === id) {
                            menu['submenu'].map((smenu) => {
                                if (smenu['route'] === slug) {
                                    this.setState((state) => ({
                                        "showAdd": JSON.parse(smenu['permissions']['add']),
                                        "showEdit": JSON.parse(smenu['permissions']['edit'])
                                    }));
                                }
                            })
                        }
                    }
                })

                this.setState((state) => ({
                    'loadding': true, dateTo: moment().format('YYYY-MM-DD'),
                    activePage: 1,
                    totalItemsCount: 0,
                    dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
                    'thead': [],
                    'tbody': [],
                    'downloadtbody': [],
                }), () => {
                    this.loadPage();
                })

                    let formSchema = Object.assign({}, formDataSchema);
                    formSchema['feilds'].map((feild, key) => {
                        formSchema['feilds'][key]['value'] = null;
                        formSchema['feilds'][key]['valid'] = false;
                        formSchema['feilds'][key]['errors'] = [];
                        delete formSchema['feilds'][key]['text'];
            
                    })
                    this.setState(({ 'formData': formSchema['feilds'] }), () => {
                        this.fetchData(this.state.formData);
                        // this.renderHead();
                        this.loadPage()
                    })
                //    }
            }
            
        
        } catch (error) {
            console.log(error);
        }
    }

    componentWillUnmount() {
        $('footer').css({ 'position': 'relative', top: 'unset' });
        this.setState({ formData: [] });
    }

    fetchData(fetchData) {
        var payload = {
            "unit_id": null,
            "from_date": this.state.dateFrom,
            "to_date": this.state.dateTo,
            "page": this.state.activePage
        }
        console.log('payload:', payload);
    }

    loadPage = (isDatefilter = false) => {
        try {
            let { activePage } = this.state;
            let { slug } = this.props.match.params;
            const { getTokenTatReport, getRecounsellingReport, getPlannedAdmissionsReport, getEstimateVarianceReport, getIdleTatReport, getBillTrackingTatReport,getRemarksReport,getLogReport } = networkList;
            let tableHead = [];
            let data = [];
            let This = this;
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            this.setState({downloadStatus: 0})
            tableHead = [
                {
                    "key": 'ip_no',
                    'label': 'Ip Number'
                }, 
                {
                    "key": 'patient_umr',
                    'label': 'Umr No'
                },
                {
                    "key": 'patient_name',
                    'label': 'Patient Name'
                },
                {
                    "key": 'insurance_name',
                    'label': 'Insurance Company Name'
                }, 
                {
                    "key": 'rn_preauth_requested_time',
                    'label': 'Query Raised Time'
                },
                {
                    "key": 'assigned_time',
                    'label': 'Assigned Time'
                },
                {
                    "key": 'assigned_by',
                    'label': 'Assigned By'
                },
                {
                    "key": 'assigned_to',
                    'label': 'Assigned To'
                },
                {
                    "key": 'payer_remarks',
                    'label': 'Query Description'
                },  
                {
                    "key": 'case_status',
                    'label': 'Case Status'
                },
                {
                    "key": 'assigned_time_to_insu_exec',
                    'label': 'Query Response Time by Assignee'
                },
                {
                    "key": 'response_time_by_insurance_executive',
                    'label': 'Final Query Response Time'
                }
            ]
            this.setState((state) => ({ showFilter: true, tableTitle: 'Query Report', thead: tableHead, filename: 'Query-Report.csv', loadding: true, download_btn: true, select2: false, search: false }), () => {
                postService('getQueryReport', 'POST', {
                    "data": {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                        "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                        "export": 0,
                        "page_no": isDatefilter ? 1 : activePage
                    }
                }).then(res => {
                    console.log('tat report:', res.data);
                    if (res.status) {
                        res.data.map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                res.data[key][dataKey] = ((res.data[key][dataKey] && res.data[key][dataKey] !== '--') || (res.data[key][dataKey] == 0) && (res.data[key][dataKey]!==''))  ? res.data[key][dataKey] : 'NA'
                            })
                        })                                
                        this.setState((state) => ({ tbody: res.data, totalItemsCount: res.total_items, data: data, loadding: false }));
                        // enable downloadbtn after 2sec
                        setTimeout(function () {
                        This.setState((state) => ({ downloadStatus: 1 }))
                        }, 2000);
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }

                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }
    handleChange(ele) {
        console.log(ele);
        var formFeilds = this.state.formData;
        this.setState(({
            activePage: 1,
            totalItemsCount: 0, doctor_id: formFeilds[0].value, payment_type: parseInt(formFeilds[1].value), searchwords: formFeilds[2].value
        }), () => {
            this.loadPage()
        })
    }
    handlePageChange(page) {
        console.log(page);
        this.setState((state) => ({
            tbody: [],
            activePage: page,
        }), () => {
            this.loadPage();
        })
    }
    search = () => {
        // let {search}=this.state
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
        }), () => {
            this.loadPage();
        })
    }
    dateRange = () => {
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
        }), () => {
            this.loadPage(true);
        })        
    }
    downloadFile = (isDatefilter = false) => {
        try {
            let { activePage } = this.state;
            let { slug } = this.props.match.params;
            const { getTokenTatReport, getRecounsellingReport, getPlannedAdmissionsReport, getEstimateVarianceReport, getIdleTatReport, getBillTrackingTatReport ,getRemarksReport,getLogReport} = networkList;
            let tableHead = [];
            let data = [];
            let This = this;
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            tableHead = [
                {
                    "key": 'ip_no',
                    'label': 'Ip Number'
                }, 
                {
                    "key": 'patient_umr',
                    'label': 'Umr No'
                },
                {
                    "key": 'patient_name',
                    'label': 'Patient Name'
                },
                {
                    "key": 'insurance_name',
                    'label': 'Insurance Company Name'
                }, 
                {
                    "key": 'rn_preauth_requested_time',
                    'label': 'Query Raised Time'
                },
                {
                    "key": 'assigned_time',
                    'label': 'Assigned Time'
                },
                {
                    "key": 'assigned_by',
                    'label': 'Assigned By'
                },
                {
                    "key": 'assigned_to',
                    'label': 'Assigned To'
                },
                {
                    "key": 'payer_remarks',
                    'label': 'Query Description'
                },  
                {
                    "key": 'case_status',
                    'label': 'Case Status'
                },
                {
                    "key": 'assigned_time_to_insu_exec',
                    'label': 'Query Response Time by Assignee'
                },
                {
                    "key": 'response_time_by_insurance_executive',
                    'label': 'Final Query Response Time'
                }
            ]
                This.setState((state) => ({ thead: tableHead, filename: 'Query-Report.csv', download_btn: true, downloadStatus: 0, loadding: true }), () => {
                    postService('getQueryReport', 'POST', {
                        "data": {
                            "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                            "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                            "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                            "export": 1,
                            "page_no": 0
                        }
                    }).then(res => {
                        console.log('tat report:', res.data);
                        if (res.status) {
                            res.data.map((data, key) => {
                                Object.keys(data).map((dataKey) => {
                                    res.data[key][dataKey] = ((res.data[key][dataKey] && res.data[key][dataKey] !== '--') || (res.data[key][dataKey] == 0) && (res.data[key][dataKey]!==''))  ? res.data[key][dataKey] : 'NA'
                                })
                            })
                            This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data, loadding: false, }));
                            this.csvLink.current.link.click()
                        } else {
                            if (res === 401) {

                            } else {
                                Modal.error({
                                    title: 'Failure',
                                    content: "Oops! something went wrong... Please try again.",
                                });
                            }
                        }
                    });
                });
        } catch (error) {
            console.log(error);
        }
    }
    render() {
        let { totalItemsCount, formData, downloadtbody, downloadStatus, tableTitle, thead, data, tbody, filename, download_btn, select2, search, activePage } = this.state;
        let { slug } = this.props.match.params;
        return (
            <div>
                <div className="clearfix">
                {
                    download_btn
                        ?
                        downloadStatus && tbody != ''
                            ?
                            <div className="float-right mb-2 mr-5 download sticky-top d-flex flex-row-reverse">
                               <button className="btn btn-success text-capitalize float-left" onClick={()=>{this.downloadFile()}}>
                                   <img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download Report</span>
                                </button>
                               <CSVLink data={downloadtbody} headers={thead} filename={filename} className="hidden" ref={this.csvLink} />
                                {/* <CSVLink data={downloadtbody} headers={thead} filename={filename}>
                                    <button className="btn btn-success text-capitalize float-left"><img src="/assets/images/icons/download1.png" alt="" className="pr-2" /> <span> Download Report</span></button>
                                </CSVLink> */}
                            </div>
                            :
                            <div className="float-right mb-2 mr-5 download sticky-top d-flex flex-row-reverse">
                                <Button className="btn btn-success-disabled text-capitalize float-left" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download Report</span></Button>
                            </div>
                        :
                        <div className="mt-5" />
                }
                </div>
                <Spin spinning={this.state.loadding}>
                    <div className="card ml-5 mr-5 mb-5 card-table">
                        <div className="card-header bg8">
                            <div className="clearfix">
                                <div className="float-left pt-1">
                                    {tableTitle}
                                </div>
                                <div className="row">
                                    {formData
                                        .map((feild, key) => {
                                            {
                                                if (feild.element === 'select2') {
                                                    return (
                                                        <div className="col-4">
                                                            {
                                                                select2
                                                                    ?
                                                                    <div className={`${feild.className
                                                                        ? feild.className
                                                                        : 'col'} ${feild.name}`}
                                                                        key={key}>
                                                                        <Select2
                                                                            selectdata={feild}
                                                                            // changedObj={this.state.changedObj}
                                                                            {...this.props}
                                                                            {...this.state}
                                                                            // Queuedata={this.state.formData}
                                                                            onselectChanges={this
                                                                                .handleChange
                                                                                .bind(this)}
                                                                        />
                                                                    </div>
                                                                    :
                                                                    null
                                                            }
                                                        </div>

                                                    )
                                                }
                                            }
                                            if (feild.element === 'input' && slug!=='log-report') {
                                                return (
                                                    <div className="">
                                                        {
                                                            search
                                                                ?
                                                                <div className="d-flex mx-auto" style={{ 'position': 'absolute', 'left': '370px' }}>
                                                                    <div
                                                                        className={`${feild.className
                                                                            ? feild.className
                                                                            : 'col'} ${feild.name}`}
                                                                        key={key}>
                                                                        <Inputlayer
                                                                            {...this.props}
                                                                            {...this.state}
                                                                            feildData={feild}
                                                                            onInputChanges={this
                                                                                .handleChange
                                                                                .bind(this)}
                                                                        />
                                                                        <div class="input-group-append">
                                                                            {/* <Button type="primary" onClick={this.search} loading={this.state.loadding}><img src="/assets/images/icons/search.png"></img></Button> */}
                                                                            <button class="btn btn-primary btn-sm" onClick={this.search}><img src={homepage+"/assets/images/icons/search.png"} /></button>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>

                                                )
                                            }

                                            if (feild.element === 'daterange') {
                                                return (
                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col '} ${feild.name}`}
                                                        key={key}>
                                                        {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}
                                                        
                                                        <DateRange
                                                            Queuedata={formData}
                                                            selectdata={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                            onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({ dateFrom: e.value[0], dateTo: e.value[1] }) }}
                                                        />
                                                       <div class="input-group-append">                                                                           
                                                            <button class="btn btn-primary btn-sm ml-1" onClick={this.dateRange}>Go</button>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })}
                                </div>
                            </div>

                        </div>

                        <div className="financial-table table-responsive sticky-header" id={slug !== 'idle-reports' ? 'table' : null}>
                            <table className="table table-hover table-bordered mb-0 bg-white">
                                <thead>
                                    <tr> 
                                        <td className="text-capitalize align-middle">S.No.</td>
                                        
                                        {thead.map((head, key) => {
                                            if( slug==='log-report'){
                                                return (<td className="text-capitalize align-middle" key={key}>{head['label'].replaceAll("_"," ")}</td>)      
                                            }
                                            if(head['label']==='Trigger  Status'){
                                                return (<td className="text-capitalize align-middle" key={key} style={{width:'10%'}}>{head['label']}</td>)
                                            }
                                           else{
                                                return (<td className="text-capitalize align-middle" key={key}>{head['label']}</td>)
                                            }
                                        })}
                                    </tr>
                                </thead>
                                {
                                    tbody != ''
                                        ?
                                        <tbody>
                                            {tbody.map((body, key) => {
                                                return (<tr key={key}>
                                                    <td>{(key + 1) + (activePage > 1 ? 20 * (activePage > 2 ? (activePage - 1) : 1) : 0)}</td>
                                                    {thead.map((head, Hkey) => {                                                                                                       
                                                        return (
                                                            <td className="text-capitalize">{(body[head['key']] !== null) ?(body[head['key']] !== "")?body[head['key']] :'NA': 'NA'}</td>
                                                        )

                                                    })
                                                    }

                                                </tr>)
                                            })}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr>
                                                <td colSpan="13" className="text-center">
                                                    <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                    <p className="no-data mb-0">No Data</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                }

                            </table>
                        </div>
                    </div>
                    <div className="row justify-content-center align-item-center mx-0">
                        <div className="col pagenation-col mb-3">
                            {/* <Pagination

                                activePage={this.state.activePage}
                                itemsCountPerPage={20}
                                totalItemsCount={totalItemsCount}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange.bind(this)}
                            /> */}

                            <Pagination current={this.state.activePage} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={20} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />


                        </div>
                    </div>

                </Spin>
            </div>
        )
    }
}

export default Query_Report;